// extracted by mini-css-extract-plugin
export default {"list":"list_m3wDZ"};